export class ApiEndPointsCore {
    getCoreListing = 'api/Core/GetCores';
    getCoreFeildList = 'api/Core/GetAllFolderFields';    
    saveCoreFieldList = 'api/Core/AddCore';
    saveCoreUserDetails = 'api/Core/UpdateCore';
    getCoreUserDetails = 'api/Core/GetCoreDetail';
    getCoreFieldColumn = 'api/CustomizedGridComponent/GetUserGridCustomizedSetting';
    updateCoreFieldColumn = 'api/CustomizedGridComponent/UpdateUserGridCustomizationSetting';
    ReorderCoreFieldColumn = 'api/CustomizedGridComponent/ReorderColumn';
    getImageUploadURL ='api/App/UploadProfilePic';

    getDefaultFilterFieldsList = 'api/Filter/GetDefaultFilterFields';
    CreateFilter = 'api/Filter/AddFillter'; 
    GetAllFillters = 'api/Filter/GetAllFillters'; 
    GetFilteredCores = 'api/Core/GetFilteredCores'; 
    AddContactTouch = 'api/ContactTouch/AddContactTouch';
    GetAllContactTouchess='api/ContactTouch/GetAllContactTouchess';
}
